import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { format } from "date-fns";
import { fr } from "date-fns/locale";
import { StockItem, InventoryItem } from "@/types/stock";

export const useInventoryData = (selectedDate?: Date) => {
  return useQuery({
    queryKey: ["inventory_data", selectedDate],
    queryFn: async () => {
      let query = supabase
        .from("stock_items")
        .select("*");

      if (selectedDate) {
        const formattedDate = format(selectedDate, "yyyy-MM-dd", { locale: fr });
        query = query.eq("date", formattedDate);
      }

      const { data, error } = await query;

      if (error) {
        throw error;
      }

      const stockItems: StockItem[] = data.map(item => ({
        id: item.id,
        stock_id: item.stock_id,
        data: {
          name: item.data?.name || "",
          unit: item.data?.unit || "",
          price: Number(item.data?.price) || 0,
          status: item.data?.status || "",
          minQuantity: Number(item.data?.minQuantity) || 0
        },
        quantity: item.quantity || 0,
        created_at: item.created_at,
        updated_at: item.updated_at,
        formattedDate: item.created_at ? format(new Date(item.created_at), "Pp", { locale: fr }) : "",
      }));

      // Group items by date
      const groupedInventories = stockItems.reduce((acc: { [key: string]: StockItem[] }, item) => {
        const date = item.formattedDate || "";
        if (!acc[date]) {
          acc[date] = [];
        }
        acc[date].push(item);
        return acc;
      }, {});

      return { groupedInventories, stockItems };
    },
  });
};